export default "__VITE_ASSET__BMwvwNUz__"